import { Component, ReactNode } from 'react'
import '../styles/error-boundary.css'
import { handleRuntimeChunkError, isChunkLoadError } from '../utils/runtimeStability'

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
  error: Error | null
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.error('ErrorBoundary caught:', {
      message: error.message,
      name: error.name,
      stack: error.stack,
      location: window.location.pathname,
      search: window.location.search,
      hash: window.location.hash,
      componentStack: errorInfo.componentStack,
      timestamp: new Date().toISOString()
    })

    if (isChunkLoadError(error)) {
      sessionStorage.setItem('cache_clear_needed', 'true')
      void handleRuntimeChunkError(error, 'error-boundary')
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: '2rem',
            textAlign: 'center',
            backgroundColor: '#f9fafb'
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '2rem',
              borderRadius: '0.5rem',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              maxWidth: '500px'
            }}
          >
            <h2
              style={{
                fontSize: '1.5rem',
                fontWeight: 'bold',
                color: '#dc2626',
                marginBottom: '1rem'
              }}
            >
              Uygulama Hatası Oluştu
            </h2>
            <p style={{ color: '#6b7280', marginBottom: '1rem' }}>
              Uygulama dosyaları yeniden senkronize edilmeye çalışılıyor.
            </p>
            <p style={{ color: '#9ca3af', fontSize: '0.875rem' }}>
              Sorun devam ederse sağ alt köşedeki bildirimden tam yenileme yapın.
            </p>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
